import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../context/ThemeContext";

const CTASection = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <Box sx={{ bgcolor: theme.navBg, py: { xs: 8, md: 10 }, transition: "background 0.5s ease" }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h3" fontWeight={700} sx={{ color: "white", mb: 2 }}>
            Ready to Get Started?
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "rgba(255,255,255,0.7)", mb: 4, maxWidth: 500, mx: "auto", lineHeight: 1.8 }}
          >
            Join thousands of property owners and tenants who have simplified their rental experience with OTS. Create your free account today.
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/signup", { state: { type: "Landlord" } })}
              sx={{
                px: 4,
                py: 1.5,
                bgcolor: "white",
                color: theme.primary,
                fontWeight: 600,
                fontSize: "1rem",
                "&:hover": { bgcolor: "rgba(255,255,255,0.9)" },
              }}
            >
              List Your Property
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate("/signup", { state: { type: "Tenant" } })}
              sx={{
                px: 4,
                py: 1.5,
                borderColor: "white",
                color: "white",
                fontWeight: 600,
                fontSize: "1rem",
                "&:hover": { bgcolor: "rgba(255,255,255,0.1)", borderColor: "white" },
              }}
            >
              Find a Rental
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;
